<template>
  <div class="chart" :id="`echart-${_uid}`" :ref="`echart-${_uid}`">
  </div>
</template>
<script>
require('echarts/lib/chart/bar');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');
require('echarts/lib/component/markLine');
require('echarts/lib/component/tooltip');
export default {
  name: 'checkResultChart',
  props: {
    Dwidth: 0,
    customColor: {
      type: String,
      default: '#3398DB'
    },
    series: {
      type: Array,
      default: () => []
    },
    title: {
      default: '模型检测数据汇总'
    }
  },
  data () {
    return {
      chart: null
    };
  },
  mounted () {
    this.drawLine();
  },
  methods: {
    init () {
    },
    drawLine () {
      let target = this.$refs[`echart-${this._uid}`];
      this.chart = this.$echarts.init(target);
      this.chart.setOption(this.options);
    }
  },
  computed: {
    _dWidth () {
      return this.Dwidth;
    },
    xData () {
      return this.series.map((a) => a.dish_name);
    },
    yData () {
      return this.series.map((a) => a.dish_acc);
    },
    options () {
      let that = this;
      return {
        title: {
          text: '模型检测数据汇总',
          x: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            // console.log(params);
            let image = that.series[params[0].dataIndex].dish_url;
            let count = that.series[params[0].dataIndex].count;
            let dish_acc = that.series[params[0].dataIndex].dish_acc;
            let errorCount = that.series[params[0].dataIndex].errorCount;
            console.log(dish_acc);
            let res =
              `${params[0].name} <br/> 准确率: ${dish_acc}<br/>  错误数: ${errorCount}<br/> 总数: ${count}<br/> 例图: <img src="${image}" alt="" width="50" height="50">`;
            return res;
          },
          textStyle: { color: '#ffff', align: 'left', fontSize: 14 }
        },
        color: this.customColor,
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            // data: [...xDatas],
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: -30
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
            // min: 80
          }
        ],
        series: [
          {
            type: 'bar',
            data: this.yData,
            barWidth: '50%'
            // markLine: {
            //   data: [
            //     {
            //       name: '平均值',
            //       xAxis: -1,
            //       yAxis: this.avarage * 100,
            //       lineStyle: {
            //         color: '#38a7f0'
            //       }},
            //     {
            //       name: '准确率红线', xAxis: -1, yAxis: 98
            //     }
            //   ],
            //   itemStyle: {
            //     normal: {
            //       lineStyle: {
            //         type: 'solid',
            //         color: '#ff0000'
            //       },
            //       label: {
            //         show: true,
            //         position: 'end'
            //       }
            //     }
            //   }
            // }
          }
        ]
      };
    }
  },
  watch: {
    _dWidth () {
      this.chart.resize();
    },
    options () {
      this.drawLine();
    }
  }
};
</script>
<style>

</style>
